import mirror from 'keymirror';
import has from 'lodash/has';
import Library from '../lib/library';
import { getLesson, getUpcomingCourses } from '../lib/finder';
import { getSongByID } from './song';
import { requestProgress } from './my-progress';

export const actionTypes = mirror({
  CLEAR_WATCHING: null,
  FC_SIGNOUT: null,
  NEXT_LESSON_IN_COURSE_IN_PATH: null,
  PATH_GET_IN_PROGRESS: null,
  PATH_GET_LIST_SUCCESS: null,
  PATH_GET_BY_ID_SUCCESS: null,
  PATH_GET_BY_SLUG_SUCCESS: null,
  PATH_GET_ERROR: null,
  PATH_SET_CURRENT: null,
});

export const clearWatching = () => ({
  type: actionTypes.CLEAR_WATCHING,
});

const pathGetInProgress = () => ({
  type: actionTypes.PATH_GET_IN_PROGRESS,
});

const pathGetListSuccess = results => ({
  type: actionTypes.PATH_GET_LIST_SUCCESS,
  results,
});

const pathGetByIdSuccess = (id, results) => ({
  type: actionTypes.PATH_GET_BY_ID_SUCCESS,
  id,
  results,
});

const pathGetBySlugSuccess = (slug, results) => ({
  type: actionTypes.PATH_GET_BY_SLUG_SUCCESS,
  slug,
  results,
});

const pathGetError = error => ({
  type: actionTypes.PATH_GET_ERROR,
  error,
});

export function getPathList(tiny) {
  return async dispatch => {
    try {
      dispatch(pathGetInProgress());
      const pathArr = await Library.getPathList(tiny);
      dispatch(pathGetListSuccess(pathArr));
      return pathArr;
    } catch (err) {
      dispatch(pathGetError(err));
    }
  };
}

export function getPathOnboarding() {
  return async dispatch => {
    try {
      dispatch(pathGetInProgress());
      const pathArr = await Library.getPathOnboarding();
      dispatch(pathGetListSuccess(pathArr));
    } catch (err) {
      dispatch(pathGetError(err));
    }
  };
}

export function getPathByID(pathID) {
  return async dispatch => {
    try {
      dispatch(pathGetInProgress());
      const path = await Library.getPathByID(pathID);
      dispatch(pathGetByIdSuccess(pathID, path));
    } catch (err) {
      dispatch(pathGetError(err));
    }
  };
}

export function getPathBySlug(pathSlug) {
  return async dispatch => {
    try {
      dispatch(pathGetInProgress());
      const path = await Library.getPathBySlug(pathSlug);
      dispatch(pathGetBySlugSuccess(pathSlug, path));
    } catch (err) {
      dispatch(pathGetError(err));
    }
  };
}

export function setCurrentPath(pathSlug, playlistSlug, courseSlug, lessonSlug) {
  return async (dispatch, getState) => {
    await getPathBySlug(pathSlug)(dispatch, getState);
    let state = getState();
    if (state.paths.results[pathSlug]) {
      await requestProgress(state.paths.results[pathSlug].id, 'paths', dispatch);
      state = getState();
      const { currentCourse } = getUpcomingCourses(state.paths, pathSlug, playlistSlug, courseSlug);
      const { currentLesson } = getLesson(currentCourse, lessonSlug);
      const lessonResp = await Library.getLessons({
        ids: [currentLesson ? currentLesson.id : undefined],
      });
      const hasItems = has(lessonResp, 'items');
      if (hasItems) {
        const hasSongID = has(lessonResp.items[0], 'song');
        const songID = hasSongID ? lessonResp.items[0].song : null;
        await getSongByID(songID)(dispatch, getState);
      }
      if (state.paths.results[pathSlug]) {
        dispatch({
          type: actionTypes.PATH_SET_CURRENT,
          currentLesson: hasItems ? lessonResp.items[0] : currentLesson,
          pathSlug,
          playlistSlug,
          courseSlug,
          lessonSlug,
          myProgress: state.myProgress,
        });
      }
    }
  };
}

export function nextLessonInCourse(currentLessonSlug) {
  return async dispatch => {
    dispatch({
      type: actionTypes.NEXT_LESSON_IN_COURSE_IN_PATH,
      currentLessonSlug,
    });
  };
}
